<script setup>
import {computed, onMounted, ref, watch} from "vue";
import store from "@/store";
import {couponConf} from "@/utils/config";
import {useRoute} from "vue-router";
import axiosApi from "@/utils/axiosApi";
import LoginComponents from "@/components/login/LoginComponents.vue";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";
import {ElMessage} from "element-plus";
import router from "@/router";

const types = computed(() => {
  return couponConf.jdxc
})
const loading = ref(false)
const showPayLoading = ref(false)
const number = ref(1)

const route = useRoute()
const coupon = ref({})
const showLogin = ref(false)
const account = computed(() => store.state.account)
const href = window.location.href
const order_from = computed(() => store.state.orderFrom)
watch(account, (to) => {
  if (!to.cust_id) {
    showLogin.value = true
  }
})
onMounted(async () => {
  store.commit("getCoupon")
  store.commit("getOrderFrom")
  await store.dispatch("getAccounts")
  getCoupon()
})

const maxNumber = computed(() => {
  let balanceMiles = parseFloat(account.value?.balance_miles || 0)
  let couponMiles = parseFloat(coupon.value?.score_data?.scal?.discount || 0)
  if (couponMiles < balanceMiles) {
    return Math.floor(balanceMiles / couponMiles)
  } else {
    return 1
  }
})

const total_miles = computed(() => {
  return number.value * coupon.value?.score_data?.scal?.discount
})

const getCoupon = () => {
  showLogin.value = false
  new axiosApi({
    encode: 'site',
    method: "coupon/cat_coupon_detail",
    body: {
      cid: route.params.id
    }
  }).send(res => {
    if (res.message.code === "000") {
      res.data.detail = res.data.detail.filter(v => v.key.length && v.value.length)
      coupon.value = res.data
      document.title = coupon.value.title
    }
  })
}
const sendSms = ref(false)
const realname = ref(false)
const payment = () => {
  if (!account.value?.cust_id) {
    showPayLoading.value = false
    showLogin.value = true
    return;
  }
  if (!sendSms.value) {
    sendSms.value = true
    return;
  }
  sendSms.value = false
  loading.value = true
  let gift_list = coupon.value?.gift?.checked;
  if (coupon.value?.active) {
    coupon.value.active.forEach(its => {
      if (its.type === 'select') {
        const checked = its?.checked || 0
        gift_list.push({id: its.list[checked].id, number: its.list[checked].number})
      }
    })
  }
  new axiosApi({
    encode: 'site',
    method: "coupon/pay",
    body: {
      coupon_id: coupon.value.id,
      uid: account.value.uid,
      pay_type: "scal",
      pay_params: JSON.stringify({
        cust_id: account.value.cust_id
      }),
      number: number.value,
      gift_list: JSON.stringify(gift_list),
      order_from: order_from.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    router.replace({name: 'success', params: {order: res.data.ordersn}})
  }, () => loading.value = false)
}
</script>

<template>
  <el-scrollbar class="page-pid page-detail" :style="types.style" v-if="Object.keys(coupon).length">
    <div class="coupon-img">
      <el-image :src="coupon?.images"/>
    </div>
    <el-card shadow="never" class="coupon-titles">
      <h4 class="title">{{ coupon?.title }}</h4>
      <el-tag type="danger" v-if="Object.keys(coupon.discount).length" style="margin: 10px 0">
        {{ coupon?.discount?.jingle }}
      </el-tag>
      <ul class="coupon-details" v-if="coupon.detail.length">
        <li class="coupon-details-info" v-for="(detail,inx) in coupon.detail" :key="inx">
          <div class="coupon-details-label">{{ detail.key }}：</div>
          <div class="coupon-details-value">{{ detail.value }}</div>
        </li>
      </ul>
    </el-card>
    <div class="divider">
    </div>
    <div class="coupon-images" v-html="coupon.remark">
    </div>
  </el-scrollbar>
  <el-empty v-else/>
  <div class="footer">
    <!--    <div class="kefu">-->
    <!--      &lt;!&ndash;        <p>&ndash;&gt;-->
    <!--      &lt;!&ndash;          <i class="ticket-font ticket-kefu"></i>&ndash;&gt;-->
    <!--      &lt;!&ndash;        </p>&ndash;&gt;-->
    <!--      &lt;!&ndash;        <p>联系客服</p>&ndash;&gt;-->
    <!--    </div>-->
    <div class="btn">
      <div class="money">
        <el-text type="danger">{{ coupon?.score_data?.scal?.discount }}</el-text>
        {{
          coupon?.score_data?.scal?.unit
        }}
      </div>
      <el-button round type="primary" size="large" color="#E12020" v-if="Object.keys(account).length"
                 :disabled="parseFloat(account.balance_miles) < parseFloat(coupon?.score_data?.scal?.discount)"
                 @click="showPayLoading=true">
        立即兑换
      </el-button>
      <el-button round type="primary" size="large" color="#E12020" v-else @click="showLogin=true">
        请登录
      </el-button>
    </div>
  </div>
  <login-components :show-login="showLogin" v-if="showLogin" @login="getCoupon"/>
  <el-drawer v-model="showPayLoading" direction="btt" class="pay-box" :size="coupon?.active?640:480">
    <template #header>
      <div class="header">
        <div class="header-logo">
          <el-image :src="types?.miniLogo"/>
        </div>
        <div class="header-title">
          <h3>{{ coupon?.title }}</h3>
          <div class="jingle">原价{{ parseFloat(coupon?.face_value) }}元{{ coupon.name }}</div>
          <div class="pay-miles"
               :class="parseFloat(coupon?.score_data?.scal?.total) > parseFloat(coupon?.score_data?.scal?.discount)?'active-prices':''">
            <span class="discount-tag"
                  v-if="parseFloat(coupon?.score_data?.scal?.total) > parseFloat(coupon?.score_data?.scal?.discount)">活动价</span>
            <span class="pay-miles-value">{{ coupon?.score_data?.scal?.discount }}</span>{{
              coupon?.score_data?.scal?.unit
            }}
          </div>
        </div>
      </div>
    </template>
    <div class="tips">
      本券兑换成功后系统将发送消费短信到川航金熊猫会员绑定手机号，消费短信为<span class="required">到店核销</span>唯一凭证，请妥善保存。
    </div>
    <el-card class="cards active" v-if="coupon.active">
      <div class="gift-title" v-for="(act,inx) in coupon.active" :key="inx">
        <el-text type="danger">{{ act.title }}</el-text>
        <div v-if="act.type === 'select'" class="gift-product">
          <div class="gift-product-lst" v-for="(pro,inx) in act.list" :key="inx">
            <el-button round :type="act?.checked === inx ?'danger':'info'" @click="act.checked = inx">{{
                pro.name
              }}
            </el-button>
          </div>
        </div>
      </div>
    </el-card>
    <el-card class="cards">
      <div class="pay-numbers">
        <div class="pay-numbers-label">兑换数量</div>
        <div class="pay-number-value">
          <el-input-number v-model="number" :max="maxNumber" :min="1"/>
        </div>
      </div>
    </el-card>
    <el-card class="cards">
      <div class="pay-numbers">
        <div class="pay-numbers-label">可用{{ coupon?.score_data?.scal.unit }}</div>
        <div class="pay-number-value">
          {{ account?.balance_miles }}
        </div>
      </div>
      <div class="pay-numbers">
        <div class="pay-numbers-label">支付{{ coupon?.score_data?.scal.unit }}</div>
        <div class="pay-number-value">
          {{ total_miles }}
        </div>
      </div>
    </el-card>
    <div class="btn">
      <el-button round type="danger" color="#E31D1A" :loading="loading" size="large"
                 :disabled="total_miles > account.balance_miles" @click="payment">立即兑换
      </el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname" :href="href"/>
</template>

<style scoped lang="less">
.page-detail {
  height: calc(100vh - 64px);
  background: var(--theme-color);
  box-sizing: border-box;

  .coupon-img {
    margin-bottom: 15px;
    padding: 15px 15px 0;
  }

  .coupon-titles {
    border-radius: 12px;
    line-height: 1.75;
    margin: 15px;

    .coupon-details {
      //margin: 15px 0;
      list-style: none;
      line-height: 1.75;
      font-size: .85rem;
      padding: 10px;
      background: var(--theme-color);
      border-radius: 8px;

      .coupon-details-info {
        display: flex;

        .coupon-details-label {
          white-space: nowrap;
        }
      }
    }
  }

  .divider {
    width: 180px;
    margin: 20px auto;
    border-top: 1px solid #999;
    position: relative;

    &:before {
      position: absolute;
      content: "图文详情";
      background: var(--theme-color);
      top: -10px;
      width: 5em;
      text-align: center;
      margin-left: -2.5em;
      left: 50%;
      font-size: .8rem;
      color: #999;
    }
  }

  /deep/ .coupon-images {
    width: 100%;
    overflow: hidden;
    padding: 0 15px 15px;
    box-sizing: border-box;

    img {
      width: 100%;
    }
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px;
  background: #ffffff;
  box-shadow: var(--el-box-shadow);

  .kefu {
    color: #E31D1A;
    text-align: center;
    font-size: .8rem;

    .ticket-font {
      font-size: 20px;
    }
  }

  //.money{
  //  margin-right: 25px;
  //}

  //.miles {
  //  color: #E31D1A;
  //}
  .btn {
    display: flex;
    align-items: center;

    .money {
      margin-right: 25px;

      .el-text {
        font-size: 1rem;
      }
    }
  }
}

.pay-box {
  .header {
    display: flex;
    line-height: 1.75;
    align-items: flex-start;

    .header-logo {
      flex-basis: 100px;
      width: 100px;
      padding: 15px;
      background: #dedede;
      border-radius: 12px;
      margin-right: 10px;
      text-align: center;

      .el-image {
        width: 85%;
        margin: auto;
        text-align: center;
      }
    }

    .jingle {
      color: #999;
      font-size: .8rem;
    }

    .pay-miles {
      position: relative;

      &.active-prices {
        margin-top: 15px;
      }

      .pay-miles-value {
        color: #E31D1A;
        font-size: 1.95rem;
        padding-right: 5px;
      }

      .discount-tag {
        position: absolute;
        right: 25px;
        top: -12px;
        font-size: .7rem;
        margin-bottom: 10px;
        background: #E31D1A;
        color: #ffffff;
        padding: 5px;
        border-radius: 8px 5px 8px;
      }
    }
  }

  .tips {
    color: #999;
    font-size: .8rem;
    line-height: 1.75;
    margin-bottom: 15px;

    .required {
      color: #E31D1A;
    }
  }

  .cards {
    margin-bottom: 15px;
    border-radius: 12px;

    &.active {
      background: url("@/assets/images/giftpack.png") no-repeat right top;
      background-size: 40px;
      box-sizing: border-box;
      padding-right: 40px;

      .gift-product {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .gift-product-lst {
          box-sizing: border-box;
          padding: 10px 10px 5px;
          width: 50%;

          .el-button {
            width: 100%;
          }
        }
      }
    }

    .pay-numbers {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

      & + .pay-numbers {
        //margin-top: 15px;
        border-top: var(--el-border);
      }
    }
  }

  .btn {
    text-align: center;

    .el-button {
      width: 90%;
      margin: auto;
    }
  }
}
</style>
